import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Widget } from '@src/shared/ui/components/Widget';
import { Skeleton } from '@src/shared/ui/components/Widget/components/Skeleton';
import { isEmpty } from 'lodash';
import React from 'react';

import { Table } from './components/Table';

/**
 * Widget: DobComparison
 *
 * @TODO Needs description.
 *
 * @param data
 * @param riskCodes
 * @returns {Element}
 * @constructor
 */
export function DobComparison({ data, riskCodes }) {
  return (
    <ErrorHandler location="src/widgets/RiskRecords/DobComparison/DobComparison.jsx">
      {isEmpty(data) ? (
        <Skeleton />
      ) : (
        <Widget description={data?.description || ''} title={data?.name || 'DOB Comparison'}>
          {data?.defaultView === 'table' && (
            <Table
              riskCodes={riskCodes}
              rows={data?.data?.content?.map((row) => {
                return {
                  amount: row?.total,
                  code: row?.label,
                };
              })}
            />
          )}
        </Widget>
      )}
    </ErrorHandler>
  );
}
